<div *ngIf="details" class="box-details">
  <div class="box-details__title typog-h2" [innerHTML]="details.title"></div>
  <div
    class="box-details__content"
    [class.box-details__content--reverse]="showDescriptionFirst"
  >
    <img
      class="box-details__image"
      [src]="details.image.src"
      [alt]="details.image.alt"
    />
    <div
      *ngIf="details.description"
      class="box-details__description"
      [innerHTML]="details.description"
    ></div>
  </div>
</div>
